







































import { Component, Vue } from 'vue-property-decorator';
import { LoginForm, ResetPassword, SendMailResetPassword, BlockAssistance } from '@/components';
import { LOGINCOMPONENTTYPE } from '@/enums';
import { stopDemo } from '@/utils';
import { EventBus } from '@/event-bus';

@Component({
  components: {
    LoginForm,
    ResetPassword,
    SendMailResetPassword,
    BlockAssistance
  }
})
export default class Login extends Vue {
  private currentComponent = LOGINCOMPONENTTYPE.LOGIN;

  mounted() {
    EventBus.$emit(stopDemo);
  }

  public goToLogin() {
    this.currentComponent = LOGINCOMPONENTTYPE.LOGIN;
  }
  public goToResetPassword() {
    this.currentComponent = LOGINCOMPONENTTYPE.RESETPASSWORD;
  }
  public goToSendMailResetPassword() {
    this.currentComponent = LOGINCOMPONENTTYPE.SENDMAIL;
  }

  public checkConcernedComponent(caller: LOGINCOMPONENTTYPE): boolean {
    return caller === this.currentComponent;
  }

  get componentTypeEnum(): typeof LOGINCOMPONENTTYPE {
    return LOGINCOMPONENTTYPE;
  }
}
